import React from 'react';
import { PARTNERS } from '../data/mockData';

const Partners = () => {
  return (
    <section className="py-20 bg-[#f8f7f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-2 text-xs font-semibold tracking-[0.2em] text-[#DAA520] border border-[#DAA520]/30 rounded-sm mb-4">
            TRUSTED PARTNERS
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
            Our Association
          </h2>
          <div className="w-12 h-0.5 bg-[#DAA520] mx-auto mb-4" />
          <p className="text-gray-600 max-w-xl mx-auto">
            We partner with India's most renowned developers to bring you the finest properties
          </p>
        </div>

        {/* Partner Logos Scrolling */}
        <div className="relative overflow-hidden">
          <div className="flex animate-scroll-partners">
            {[...PARTNERS, ...PARTNERS].map((partner, index) => (
              <div
                key={index}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
              >
                <div className="bg-white rounded-lg shadow-md px-8 py-6 min-w-[180px] h-24 flex items-center justify-center hover:shadow-lg hover:scale-105 transition-all duration-300 border border-gray-100">
                  <span className="text-lg font-bold tracking-wider text-gray-800">
                    {partner.logo}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
